import { useFirebaseStore } from '~/store/firebase';
import { useGamesStore } from '~/store/games';
import { useModalStore } from '~/store/modal';
import { useSignUpStore } from '~/store/sign-up';
import { useUserStore } from '~/store/user';

interface IStores {
  user: ReturnType<typeof useUserStore>;
  games: ReturnType<typeof useGamesStore>;
  modals: ReturnType<typeof useModalStore>;
  firebase: ReturnType<typeof useFirebaseStore>;
  signUp: ReturnType<typeof useSignUpStore>;
}

export const stores = {} as unknown as IStores;

export function initStores() {
  Object.assign(stores, {
    user: useUserStore(),
    games: useGamesStore(),
    modals: useModalStore(),
    firebase: useFirebaseStore(),
    signUp: useSignUpStore(),
  });
}
